export default "__VITE_ASSET__CIMpK78a__"